import React from 'react';

const Contact = () => {
  return <section className='section bg-amber-500'>Contact</section>;
};

export default Contact;
